import gql from 'graphql-tag'

export const policy = gql`
 query policy($locale: SiteLocale) {
  policy(locale: $locale) {
    text
     seo {
        title
        image {
          url
        }
        description
      }
    }
  }
`
